module.exports = __webpack_public_path__ + "img/d7107.b467af16.png";